// Definição para o modal de busca de Contas Bancárias (self-reference para IdContaPrincipal)
// Aceita um parâmetro opcional lstTipoConta para filtrar por tipo de conta específico.
// Quando fornecido, o tipo é aplicado como filtro fixo e removido dos filtros/colunas dinâmicos.
export function contaBancariaSearch (lstTipoConta) {
  const filtrosFixos = {}
  if (lstTipoConta) {
    filtrosFixos.lstTipoConta = lstTipoConta
  }

  return {
    label: 'Conta Bancária',
    placeholder: 'Descrição...',
    titulo: 'Selecionar Conta Corrente Principal',
    endpointApi: 'ContasBancarias',
    idField: 'idContaBancaria',
    displayField: 'idContaBancaria',
    descField: 'descricao',
    tabela: 'ContaBancaria',
    filtrosFixos,

    camposFiltro: [
      { label: 'Descrição', model: 'termoBusca', tipo: 'text' },
      ...(lstTipoConta ? [] : [{ label: 'Tipo de Conta', model: 'lstTipoConta', tipo: 'listabusca' }]),
      { label: 'Status', model: 'lstStatus', tipo: 'text' }
    ],

    colunasGrid: [
      { header: 'ID', dataField: 'idContaBancaria', width: '10%' },
      { header: 'Descrição', dataField: 'descricao', width: '30%' },
      ...(lstTipoConta ? [] : [{ header: 'Tipo de Conta', dataField: 'lstTipoConta', width: '15%' }]),
      { header: 'Agência', dataField: 'agencia', width: '15%' },
      { header: 'Conta', dataField: 'numeroConta', width: '20%' },
      { header: 'Status', dataField: 'lstStatus', width: '10%' }
    ]
  }
}
